export enum InvoiceOption {
  RENT= 0,
  HEATING = 1,
  COLD_WATER = 2,
  WARM_WATER =3,
}
